import { render, staticRenderFns } from "./UnitConversionBrowsingHistory.vue?vue&type=template&id=0f5a84d2&scoped=true"
import script from "./UnitConversionBrowsingHistory.vue?vue&type=script&lang=js"
export * from "./UnitConversionBrowsingHistory.vue?vue&type=script&lang=js"
import style0 from "./UnitConversionBrowsingHistory.vue?vue&type=style&index=0&id=0f5a84d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a84d2",
  null
  
)

export default component.exports